import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { usePersonnelTypesUIContext } from "../PersonnelTypesUIContext";

const prepareFilter = (queryParams, values) => {
  const { name, definition } = values;
  const newQueryParams = { ...queryParams };
  const filter = { name, definition };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function PersonnelTypesFilter() {
  // PersonnelTypes UI Context
  const personnelTypesUIContext = usePersonnelTypesUIContext();
  const personnelTypesUIProps = useMemo(() => {
    return {
      setQueryParams: personnelTypesUIContext.setQueryParams,
      queryParams: personnelTypesUIContext.queryParams,
    };
  }, [personnelTypesUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(personnelTypesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, personnelTypesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      personnelTypesUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        name: "",
        definition: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="definition"
                placeholder="Tanımı"
                onBlur={handleBlur}
                value={values.definition}
                onChange={(e) => {
                  setFieldValue("definition", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Tanımı</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}